import { getFetch } from '@legacy/utils/fetcher';
import { useQuery } from '@tanstack/react-query';
import { IInvoicedPerMonth } from '@legacy/apis/types/invoicedPerMonthAPI';

const GET_INVOICED_PER_MONTH_REPORTING_WIDGET_URL_PATH =
  '/api/v2/insights-service/invoiced-per-month';
const GET_INVOICED_PER_MONTH_REPORTING_WIDGET_MSW_STATUS_KEY =
  'getInvoicedPerMonthAPI';

const GET_INVOICED_PER_MONTH_REPORTING_WIDGET_KEY =
  'GET_INVOICED_PER_MONTH_REPORTING_WIDGET_KEY';

const getInvoicedPerMonthReportingWidget = (): Promise<IInvoicedPerMonth> =>
  getFetch({
    path: GET_INVOICED_PER_MONTH_REPORTING_WIDGET_URL_PATH,
    key: GET_INVOICED_PER_MONTH_REPORTING_WIDGET_MSW_STATUS_KEY,
  });

export const useGetInvoicedPerMonthReportingWidget = () => {
  const { data, ...restProps } = useQuery({
    queryKey: [GET_INVOICED_PER_MONTH_REPORTING_WIDGET_KEY],

    queryFn: () => getInvoicedPerMonthReportingWidget(),
  });

  if (data?.properties) {
    return {
      widgetName: data?.properties.type,
      widgetData: data?.properties.data,
      currencyAbb: data?.properties.baseCurrencyAbb,
      isEmpty: data?.properties.data.length === 0,
      ...restProps,
    };
  }

  return {
    widgetName: '',
    widgetData: [],
    currencyAbb: '',
    isEmpty: true,
    ...restProps,
  };
};
